export * from './lib/shared-feature-modules-component-switcher.module';
export * from './lib/component-switcher/component-switcher.component';
